"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearFilled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.ClearFilled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M7 1.5C6.30964 1.5 5.75 2.05964 5.75 2.75V3.75001H2.75C2.05964 3.75001 1.5 4.30965 1.5 5.00001V7.25C1.5 7.66421 1.83579 8 2.25 8H3V13.25C3 13.9404 3.55964 14.5 4.25 14.5H11.75C12.4404 14.5 13 13.9404 13 13.25V8H13.75C14.1642 8 14.5 7.66421 14.5 7.25V5.00001C14.5 4.30965 13.9404 3.75001 13.25 3.75001H10.25V2.75C10.25 2.05964 9.69036 1.5 9 1.5H7ZM3 6.5H13V5.25001H9.5C9.08579 5.25001 8.75 4.91422 8.75 4.50001V3H7.25V4.50001C7.25 4.91422 6.91421 5.25001 6.5 5.25001H3V6.5ZM7.25 11.25C7.25 10.8358 6.91421 10.5 6.5 10.5C6.08579 10.5 5.75 10.8358 5.75 11.25V12.75C5.75 13.1642 6.08579 13.5 6.5 13.5C6.91421 13.5 7.25 13.1642 7.25 12.75V11.25ZM10.25 11.25C10.25 10.8358 9.91421 10.5 9.5 10.5C9.08579 10.5 8.75 10.8358 8.75 11.25V12.75C8.75 13.1642 9.08579 13.5 9.5 13.5C9.91421 13.5 10.25 13.1642 10.25 12.75V11.25Z", fill: colors[0], fillRule: "evenodd", clipRule: "evenodd" }));
    },
    name: 'clear_filled',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M7 1.5C6.30964 1.5 5.75 2.05964 5.75 2.75V3.75001H2.75C2.05964 3.75001 1.5 4.30965 1.5 5.00001V7.25C1.5 7.66421 1.83579 8 2.25 8H3V13.25C3 13.9404 3.55964 14.5 4.25 14.5H11.75C12.4404 14.5 13 13.9404 13 13.25V8H13.75C14.1642 8 14.5 7.66421 14.5 7.25V5.00001C14.5 4.30965 13.9404 3.75001 13.25 3.75001H10.25V2.75C10.25 2.05964 9.69036 1.5 9 1.5H7ZM3 6.5H13V5.25001H9.5C9.08579 5.25001 8.75 4.91422 8.75 4.50001V3H7.25V4.50001C7.25 4.91422 6.91421 5.25001 6.5 5.25001H3V6.5ZM7.25 11.25C7.25 10.8358 6.91421 10.5 6.5 10.5C6.08579 10.5 5.75 10.8358 5.75 11.25V12.75C5.75 13.1642 6.08579 13.5 6.5 13.5C6.91421 13.5 7.25 13.1642 7.25 12.75V11.25ZM10.25 11.25C10.25 10.8358 9.91421 10.5 9.5 10.5C9.08579 10.5 8.75 10.8358 8.75 11.25V12.75C8.75 13.1642 9.08579 13.5 9.5 13.5C9.91421 13.5 10.25 13.1642 10.25 12.75V11.25Z'],
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
});
